<div class="users-wrapper">
  <div class="users-header">
    <p class="users-title">
      <span class="material-symbols-rounded group-icon">group</span>
      {{ "admin.users.title" | translate }}
    </p>
    <div class="users-controls">
      <!-- Search input -->
      <div class="users-search">
        <input
          #filter
          (input)="onSearchChange(filter.value)"
          [placeholder]="'admin.users.searchPlaceholder' | translate"
          type="text"
        />
        <span class="material-symbols-rounded text-base">search</span>
      </div>
      <div class="users-filters flex gap-4">
        <app-multi-select-dropdown
          (selectedChange)="onProfileChange($event)"
          [(selected)]="selectedProfiles"
          [label]="'admin.users.profileLabel' | translate"
          [multiple]="true"
          [options]="profileOptions"
        />

        <app-multi-select-dropdown
          (selectedChange)="onStatusChange($event)"
          [(selected)]="selectedStatus"
          [label]="'admin.users.statusLabel' | translate"
          [multiple]="true"
          [options]="statusOptions"
        />

        @if (selectedProfiles.length || selectedStatus.length) {
          <button
            class="text-sm text-[#6A7381] hover:underline"
            (click)="clearFilters()"
          >
            {{ "admin.users.clearFilters" | translate }}
          </button>
        }
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="users-table-wrapper">
    <div class="users-table-outer">
      <table class="users-table">
        <thead>
          <tr class="table-header-row">
            <th (click)="onSort('id')" class="cursor-pointer rounded-tl-2xl">
              {{ "admin.users.tableHeaders.id" | translate }}
              @if (sortColumn === "id") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('name')" class="cursor-pointer">
              {{ "admin.users.tableHeaders.user" | translate }}
              @if (sortColumn === "name") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('gerberFileCount')" class="cursor-pointer">
              {{ "admin.users.tableHeaders.gerber" | translate }}
              @if (sortColumn === "gerberFileCount") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('lectraFileCount')" class="cursor-pointer">
              {{ "admin.users.tableHeaders.lectra" | translate }}
              @if (sortColumn === "lectraFileCount") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('isActive')" class="cursor-pointer">
              {{ "admin.users.tableHeaders.status" | translate }}
              @if (sortColumn === "isActive") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('lastAccess')" class="cursor-pointer">
              {{ "admin.users.tableHeaders.lastAccess" | translate }}
              @if (sortColumn === "lastAccess") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th class="rounded-tr-2xl"></th>
          </tr>
        </thead>

        @if (users$ | async; as users) {
          <tbody>
            @for (user of users.items; track user.id) {
              <tr class="table-row">
                <td>
                  <strong>{{ user.oidcId }}</strong>
                </td>

                <td>
                  {{ user.name }}<br />
                  {{ user.email }}
                </td>

                <td>
                  {{ userUtils.getGerberCount(user) }}
                  {{ "admin.users.files" | translate }}
                </td>
                <td>
                  {{ userUtils.getLectraCount(user) }}
                  {{ "admin.users.files" | translate }}
                </td>

                <td>
                  <span class="user-status-label">
                    <span
                      class="status-dot"
                      [ngClass]="{
                        'bg-green-400': user.isActive,
                        'bg-red-400': !user.isActive,
                      }"
                    ></span>
                    {{ userUtils.mapUserStatus(user.isActive) }}
                  </span>
                </td>

                <td>
                  {{ dateUtils.formatIsoToDateTime(user.lastAccess) }}
                </td>

                <td class="relative">
                  <div class="flex justify-end">
                    <button
                      (click)="toggleOptionsDropdown(user.id)"
                      class="options-button"
                      [title]="'admin.users.options' | translate"
                    >
                      <span class="material-symbols-rounded">more_vert</span>
                    </button>
                  </div>

                  @if (optionsDropdownOpen === user.id) {
                    <ul class="options-dropdown">
                      <li>
                        <a
                          [routerLink]="['details', user.id]"
                          [state]="user"
                          class="dropdown-item"
                        >
                          {{ "admin.users.viewDetails" | translate }}
                        </a>
                      </li>
                      <li>
                        <button
                          class="dropdown-item disable-btn"
                          (click)="openStatusModal(user)"
                        >
                          {{
                            user.isActive
                              ? ("admin.users.disable" | translate)
                              : ("admin.users.enable" | translate)
                          }}
                        </button>
                      </li>
                    </ul>
                  }
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  </div>
  <div>
    @if (users$ | async; as users) {
      <app-pagination
        [currentPage]="users.page"
        [totalPages]="users.totalPages"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      />
    }
  </div>
</div>

@if (showModal && selectedUser) {
  <app-user-status-modal
    [user]="selectedUser"
    (confirm)="confirmUpdateStatus()"
    (cancel)="closeStatusModal()"
  />
}
